import { SagaIterator } from '@redux-saga/core'
import { takeEvery, all, call } from 'redux-saga/effects'
import { workerFetchUserData } from './workers'
import { TFetchUserData } from '../types'

export default function* watchProfile(): SagaIterator {
  yield takeEvery<TFetchUserData>('FETCH_USER_DATA', workerFetchUserData)
}
